import { Alert } from "components/alert/Alert";
import Time from "common/Time";
import { Notification } from "models/Notification";

import "./AlertWithAction.scss";

type Props = {
  message: Notification;
  onReadTriggered: (messageId: string) => void;
};

export default function AlertWithAction({
  message,
  onReadTriggered,
}: Props) {
  const getAlertContent = () => {
    const alertVariant = "success";
    const onDismiss  = onReadTriggered;
    return { alertVariant, onDismiss };
  };

  return (
    <Alert
      variant={getAlertContent().alertVariant}
      onDismiss={getAlertContent().onDismiss}
      className="mb-5 w-100"
    >
      <>
        <div>
          <div className="message">{message.message}</div>
          <time className="notificationBoxTime">
            {Time.formatLong(message.createdAt)}
          </time>
        </div>
      </>
    </Alert>
  );
}
